module.exports = __webpack_public_path__ + "static/media/main.3cc47d0f.png";